module.exports = __webpack_public_path__ + "img/subcurve2.4bb53790.svg";